import { currentMetricsMetaSelector } from '@src/store/common/selectors';
import { setMetrics } from '@src/store/metricsChartContainer/actions';
import { useAtomValue, useSetAtom } from 'jotai';
import { useSelector, useDispatch } from 'react-redux';
import { errorResponseAtom, queryMetricsAtom } from '../atoms/index';

export const useRefetchOnMetricDeleteError = () => {
  const dispatch = useDispatch();
  const errorData = useAtomValue(errorResponseAtom) || {};
  const metrics = useAtomValue(queryMetricsAtom);
  const setQueryMetrics = useSetAtom(queryMetricsAtom);
  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);

  // if any error response contains error for a metric
  // or metricmeta does not have a metric
  // remove from the metric list.
  const newMetricList = metrics.filter(
    (metric) => !errorData[metric] && currentMetricsMeta[metric],
  );

  if (newMetricList.length != metrics.length) {
    dispatch(setMetrics(newMetricList)); // update metric container with updated metrics
    setQueryMetrics(newMetricList); // update metric list to be queried with updated metrics
  }
};
